import { ILoginCompleted } from '@/types';
import { runFetch } from './request';

export async function postLogin(form: FormData): Promise<ILoginCompleted> {
  const result: ILoginCompleted = await runFetch('token/login/', {method: 'POST', redirect: 'follow', body: form});
  
  return result;
}